/* Web Application Map */
import React, { lazy } from 'react';
import { Redirect } from 'react-router';
import { Route } from 'react-router-dom';
import Page from 'skrit-web-framework/components/Page';

export const routes = [
    {
        path: '/',
        exact: true,
        component: lazy(() => import('../ventanas/dashboard/Dashboard')),
    },
    {
        path: '/perfil',
        exact: true,
        component: lazy(() => import('../ventanas/perfil/Perfil')),
    },
    {
        path: '/usuarios',
        exact: true,
        component: lazy(() => import('../ventanas/perfil/usuarios/Usuarios')),
    },
    {
        path: '/logout',
        component: lazy(() => import('../ventanas/login/logout')),
    },
    {
        path: '/busqueda-motos',
        component: lazy(() => import('../ventanas/motos/BusquedaMotos')),
    },
    {
        path: '/referencia',
        component: lazy(() => import('../ventanas/Referencia')),
    },
];

export const RouteWithSubRoutes = (route) => (
    <Route
        exact={route.exact}
        path={route.path}
        render={(props) =>
            localStorage.getItem('isLogged') === 'true' ? (
                <Page>
                    <route.component {...props} routes={route.routes} />
                </Page>
            ) : (
                <Redirect to='login' />
            )
        }
    />
);
